// Pomona's majors (#2596, founder 2026-09-30: "majors offered by the college in
// the public page"). Read on 2026-09-30 from the official Pomona College Catalog's
// Programs list (catalog.pomona.edu/programs), which pages through 108 programs;
// the full list came from the same Coursedog search the page runs (saved as
// programs_api.json). Every program the Catalog types as a Major is here, all
// Bachelor of Arts; the 44 minors are left out. Pomona is one college, so there
// is one group. The Public Policy Analysis and Philosophy, Politics and Economics
// tracks are listed as majors in the Catalog, so they are kept under the
// Catalog's names. The college file has no program requirements, so nothing is
// flagged. The KB's majors list was the starting point; the Catalog wins.
const majors = {
    "slug": "pomona-college",
    "read": "2026-09-30",
    "intro": "Every major in Pomona's official College Catalog, all leading to the Bachelor of Arts. Minors are left out.",
    "groups": [
        {
            "name": "Majors",
            "source": {
                "label": "Pomona College Catalog, Programs",
                "url": "https://catalog.pomona.edu/programs"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "BA"
                },
                {
                    "name": "American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Asian American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chicana/o-Latina/o Studies",
                    "degree": "BA"
                },
                {
                    "name": "Chinese",
                    "degree": "BA"
                },
                {
                    "name": "Classics",
                    "degree": "BA"
                },
                {
                    "name": "Cognitive Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Dance",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Analysis",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Gender & Women's Studies",
                    "degree": "BA"
                },
                {
                    "name": "Geology",
                    "degree": "BA"
                },
                {
                    "name": "German Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "International Relations",
                    "degree": "BA"
                },
                {
                    "name": "Japanese",
                    "degree": "BA"
                },
                {
                    "name": "Late Antique-Medieval Studies",
                    "degree": "BA"
                },
                {
                    "name": "Latin American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Media Studies",
                    "degree": "BA"
                },
                {
                    "name": "Middle Eastern Studies",
                    "degree": "BA"
                },
                {
                    "name": "Molecular Biology",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy, Politics and Economics",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy, Politics and Economics-Economics",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy, Politics and Economics-Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy, Politics and Economics-Politics",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy-Bioethics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Politics",
                    "degree": "BA"
                },
                {
                    "name": "Psychological Science",
                    "degree": "BA"
                },
                {
                    "name": "Public Policy Analysis",
                    "degree": "BA"
                },
                {
                    "name": "Public Policy Analysis-Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Public Policy Analysis-Biology",
                    "degree": "BA"
                },
                {
                    "name": "Public Policy Analysis-Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Public Policy Analysis-Economics",
                    "degree": "BA"
                },
                {
                    "name": "Public Policy Analysis-Environmental Analysis",
                    "degree": "BA"
                },
                {
                    "name": "Public Policy Analysis-Geology",
                    "degree": "BA"
                },
                {
                    "name": "Public Policy Analysis-Physics",
                    "degree": "BA"
                },
                {
                    "name": "Public Policy Analysis-Politics",
                    "degree": "BA"
                },
                {
                    "name": "Public Policy Analysis-Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Public Policy Analysis-Science, Technology, and Society",
                    "degree": "BA"
                },
                {
                    "name": "Public Policy Analysis-Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Public Policy-Economics",
                    "degree": "BA"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Romance Language and Literatures",
                    "degree": "BA"
                },
                {
                    "name": "Russian",
                    "degree": "BA"
                },
                {
                    "name": "Russian & Eastern European Studies",
                    "degree": "BA"
                },
                {
                    "name": "Science, Technology and Society",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Theatre",
                    "degree": "BA"
                }
            ]
        }
    ]
};

export default majors;
